import t from "./types";
import { Api } from '../../services/httpService';
import { dispatch } from "react-hot-toast";

export const getMenuList = (appType) => async (dispatch) => {
  const res = await Api('get', `/menu/getMenuForApp/${appType}`)
  if (res) {
      res.body?.sort((a,b)=>a.id - b.id)
      await dispatch({ type: t.GET_MENULISTS, payload: res })
  }
}

export const getUserAccessList = (roleId,type) => async (dispatch) => {
  const res = await Api('get', `/common/getGenericSPData/getMenuByRole?roleId=${roleId}&type=${type}`)
  if (res) {
      await dispatch({ type: t.GET_USERACCESS, payload: res })
  }
}

export const addEditMenuAccess = (param) => async (dispatch) => {
  try {
      let res = await Api("POST", '/menu/menuAccess/entry', param);
  } catch (error) {
      console.log("error", error);
  }
} 


export const getPermissionAccess = (roleId,type) => async (dispatch) => {
  // return async (dispatch) => {
      dispatch({ type: t.FETCH_PERMISSSION_REQUEST});
      try {
          const res = await Api('get', `/common/getGenericSPData/getMenuByRole?roleId=${roleId}&type=${type}`)
          if (res) {
              await dispatch({ type: t.FETCH_PERMISSSION_SUCCESS, payload: res })
              // await dispatch({ type: t.GET_USERACCESS, payload: res })
          }
      } catch (error) {
          // dispatch({ type: 'FETCH_DATA_FAILURE', error: error.message });
          console.log("error", error);
      }
  // };
}